module.exports = __webpack_public_path__ + "img/applicationFailed.db556968.png";